import React, { Component, useEffect } from 'react';
import { Formik, Form, ErrorMessage } from 'formik';
import { FormikTextField } from 'formik-material-fields';
import * as Yup from 'yup';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from 'react-router-dom';
import { dataService } from '../../Services/data.service';

export default function LoginPage(props) {

    const classes = useStyles();
    let history = useHistory()

    useEffect(() => {
        if (props.authentication.loggedIn) {
            history.push('/');
        }
    }, [])

    const submitLoginForm = ({ username, password }, { setStatus, setSubmitting }) => {

        setStatus();
        setSubmitting(true);
        dataService.authenticate(username, password)
            .then(
                loginResult => {
                    if(loginResult){
                        if (loginResult.Succeeded) {
                            history.push('/');
                            props.actions.login(loginResult.Results[0].FirstName,loginResult.Results[0].UserId)
    
                        } else {
                            // Show feedback api
                            props.actions.logout();
                            setStatus(loginResult.Messages[0]);
                            setSubmitting(false);
                        }
                    }                   
                },
                error => {
                    setStatus(error.message);
                    setSubmitting(false);
                }
            );
    };

    return (
        <div className={classes.background}>
            <div className="spacer200"></div>
            <Formik
                initialValues={{ username: '', password: '' }}
                validationSchema={Yup.object().shape({
                    username: Yup.string().required('Username is required'),
                    password: Yup.string().required('Password is required')
                })}
                onSubmit={submitLoginForm}>
                {({ errors, status, touched, isSubmitting }) => (
                    <div className={classes.loginContainer}>
                        <div className={classes.paper}>
                            <div className={classes.logoContainer}>
                                <img className={classes.logo} src={process.env.PUBLIC_URL + "/img/mydibel-logo.svg"} />
                            </div>


                            <h1 className={classes.formTitle}>Login</h1>
                            {status &&
                                <div className={classes.validationFeedback}>{status}</div>
                            }
                            <Form>
                                <div className="form-group">
                                    <FormikTextField
                                        name="username"
                                        type="text"
                                        fullWidth
                                        className={(errors.username && touched.username ? ' is-invalid' : '')}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start" >
                                                    <img src={process.env.PUBLIC_URL + "/img/userIcon.svg"} />
                                                </InputAdornment>
                                            ),
                                        }} />
                                </div>
                                <div className="spacer10"></div>
                                <div className="form-group">
                                    <FormikTextField
                                        name="password"
                                        type="password"
                                        fullWidth
                                        className={(errors.password && touched.password ? ' is-invalid' : '')}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <img src={process.env.PUBLIC_URL + "/img/passwordIcon.svg"} />
                                                </InputAdornment>
                                            ),
                                        }} />
                                </div>
                                <div className="spacer30"></div>
                                <div className="form-group">
                                    <Button fullWidth variant="contained" color="primary" type="submit" className="btn btn-primary" disabled={isSubmitting}>
                                        {isSubmitting &&
                                            <div className={classes.CenteredContent}>
                                                <img alt='loading' src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                            </div>
                                        }<div className="whiteText">Login</div>
                                    </Button>
                                </div>
                            </Form>
                        </div>

                    </div>
                )}
            </Formik>
        </div>
    )
}

const useStyles = makeStyles({
    background: {
        backgroundColor: "#eee",
        background: 'url(' + process.env.PUBLIC_URL + '/img/loginBackground.png)',
        height: "100vh"
    },
    formTitle: {
        color: "#1583C3",
        fontSize: "35px",
        fontWeight: 100,
        fontFamily:"Roboto",
        marginLeft: "5%",
        marginTop: "20px",
        textAlign: "center"
    },
    loginContainer: {
        width: "400px",
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingTop: "260px",
        backgroundColor: 'rgb(1,1,1,0)',
        paddingBottom: "20px"
    },
    logoContainer: {
        textAlign: "center"
    },
    logo: {
        marginTop: "-70px",
    },
    validationFeedback: {
        marginLeft: "5%",
        marginBottom: "10px",
        color: "red",
        fontWeight: 600,
        width: "90%"
    },
    CenteredContent: {
        justifyContent: 'center',
        alignContent: 'center'
    },
    paper:{
        backgroundColor:"white",
        padding:"20px"
    }
});

